













import Vue from 'vue';
import Component from 'vue-class-component';
import Login from './login/Login.vue';
import SignUp from './signUp/SignUp.vue';
import GoogleSignIn from './googleSignIn/GoogleSignIn.vue';
import EventBus from '@/services/eventBus';

@Component({
    components: {
        Login,
        SignUp,
        GoogleSignIn,
    },
})
export default class IdentityButtons extends Vue {
    setUserData() {
        const self = this;
        this.$store.dispatch('setUserIdentity');

        EventBus.$emit('showLoader', false);
    }
}
